import { useEffect } from "react";

// Custom hook for handling click outside a specified ref
function useOnClickOutside(ref1, handler) {
  useEffect(() => {
    // Event listener to check if a click occurs outside the specified ref
    const listener = (event) => {
      // Check if the ref exists and if the clicked element is outside the ref
      if (!ref1.current || ref1.current.contains(event.target)) {
        return;
      }
      // Invoke the handler function when a click occurs outside the ref
      handler(event);
    };

    // Attach event listeners for mouse click and touch start
    document.addEventListener("mousedown", listener);
    document.addEventListener("touchstart", listener);

    // Cleanup: Remove event listeners when the component unmounts
    return () => {
      document.removeEventListener("mousedown", listener);
      document.removeEventListener("touchstart", listener);
    };
  }, [ref1, handler]);

  // Export the custom hook for reuse
}
export default useOnClickOutside;
